import { EMAIL_REGEX } from '@constants/common';
import { PHONE_REGEX } from '@constants/schema';
import * as Yup from 'yup';

const FeedbackFormSchema = Yup.object({
    first_name: Yup.string().required('Required'),
    last_name: Yup.string().required('Required'),
    email: Yup.string()
        .email('The value must be a valid email address')
        .test('check-valid-email', 'The value must be a valid email address', (originalValue) => {
            return typeof originalValue === 'undefined' ? true : EMAIL_REGEX.test(originalValue);
        })
        .required('Required'),
    phone_number: Yup.string()
        .test('check-valid-phone-number', 'The value must be a valid phone number', (originalValue) => {
            return typeof originalValue === 'undefined' ? true : PHONE_REGEX.test(originalValue);
        })
        .optional()
        .nullable(),
    feedback_text: Yup.string().required('Required'),
});

export { FeedbackFormSchema };
